import {ErrorMessage, Field} from "formik";
import {useIntl} from "react-intl";

type Props = {
    label: string,
    name: string,
    type?: string,
    className?: string,
    placeholder?: string,
    as?: string,
};

export const OwFormikField = (props: Props) => {
    const intl = useIntl();

    const placeholder = props.placeholder? intl.formatMessage({id: props.placeholder}) : "";
    const label = intl.formatMessage({id: props.label});
    
    return (
        <div className="mb-4">
            <label htmlFor={props.name} className="block text-sm font-medium text-gray-700">
                {label}
            </label>
            <Field
                as={props.as || 'input'}
                type={props.type || 'text'}
                id={props.name}
                name={props.name}
                className={"form-control form-control-sm " + props.className}
                placeholder={placeholder}
            />
            <ErrorMessage
                name={props.name}
                component="p"
                className="text-danger text-xs mt-1"
            />
        </div>
    );
};
